export interface TranslationResponse {
  [language: string]: Record<string, (Record<string, string> | string)>;
}
